export default __webpack_public_path__ + "static/media/import-tires-template.80c08210.xlsx";